var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"admin-dashboard"},[_c('aside',[_c('admin-sidebar')],1),_c('div',{staticClass:"dashboard_content"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }